import SpinA11y from './SpinA11y';
export default SpinA11y;
